export default __webpack_public_path__ + "374cba9690d341fe1f5cbe21ae0e53be.jpg";